
<template>
  <div id="menuTopBar" class="layout-topbar">
    <button id="toggle-sidebar" class="p-link layout-menu-button" @click="onMenuToggle">
      <span style="font-size: 24px;" class="pi pi-bars"></span>
    </button>
    <div id="topbarIcon" class="layout-topbar-icons">
      <button id="btnNoti" class="p-link" @click="toggleNoti($event)">
        <span class="layout-topbar-item-text">Notification</span>
        <!-- <span style="font-size: 24px;" class="layout-topbar-icon fa fa-bell" v-badge.danger="2"></span> -->
        <!-- <i style ="font-size: 27px" class="material-icons" v-badge="8" badgeClass="p-badge-danger" >notifications_active</i> -->
        <BellRingOutline :value="countNotiUnread"/>
      </button>
      <OverlayPanel ref="notiOp" appendTo="body" class="mt-3 class_overlay_panel_noti" id="overlay_panel_noti" style="max-width: 600px;" :dismissable="false"   >
        <div class="noti-header justify-content-between">
          <div class="noti-header-title">Remind</div>
          <span class="p-dialog-header-close-icon pi pi-times mr-3" @click="toggleNoti()"></span>
        </div>
        <div class="noti-box" v-if="notis.length > 0">
          <!-- Thêm read all và delete all canh phải style đẹp dùm -->
          <div class="noti-header-title" style="display: flex; justify-content: flex-end; gap: 15px; padding: 5px 10px;">
    <a href="javascript:void(0)" @click="readAllNoti($event)" style="color: blue; text-decoration: none; cursor: pointer;">
        Read all
    </a>
    <a href="javascript:void(0)" @click="deleteAllNoti($event)" style="color: red; text-decoration: none; cursor: pointer;">
        Delete all
    </a>
</div>


          <div class="noti-items" @click="readNoti(item)" :class="{unread: !item.is_read, noborder: index == (notis.length-1) && notis.length >= totalNotis}" v-for="(item, index) in notis" :key="item.id" :id="`noti-${item.id}`">
            <div class="items-title" v-html="item.body"></div>
            <div class="items-date">{{ item.updated_at | formatDateTime}}</div>
            <div class="items-icon" @click.stop="delNoti(item, index)"><span class="pi pi-trash p-button-icon"></span></div>
          </div>
          <div class="noti-link-loadmore" v-if="notis.length < totalNotis">
              <span v-if="!loadingLoadMore" class="loadmore" @click.stop="loadmoreNoti()">See more <span class="pi pi-angle-down"></span></span>
              <span v-else class="loadmore">Loading data...</span>
          </div>
        </div>
        <div v-else class="noti-box box-empty">
          <div>There are no reminders</div>
        </div>
      </OverlayPanel>
      <!-- <button id="btnNoti" class="p-link">
        <span class="layout-topbar-item-text">Notification</span>
        <span style="font-size: 24px;" class="layout-topbar-icon fa fa-bell"></span>
      </button>
      
      <button id="btnProfile" class="p-link">
        <span class="layout-topbar-item-text">Setting</span>
        <span style="font-size: 24px;" class="layout-topbar-icon fa fa-gear"></span>
      </button> -->

      <button id="btnProfile" class="p-link" @click="OnShow">
        <span class="layout-topbar-item-text">User</span>
        <span style="font-size: 24px;" class="layout-topbar-icon fa fa-user"></span>
        <span style="font-size: 16px;margin-left: 10px;">{{fullname}}</span>
      </button>
      <OverlayPanel ref="op" appendTo="btnProfile" id="overlay_panel" style="width:150px">
        <div>
          <a href="#" title="Change Password" @click='openChangePassword()'>
            <div class="fontsize">Change Password</div>
          </a>
        </div>
        <hr class="new1" />
        <div>
          <a href="#" @click='submitLogout' class="fontsize" title="Logout">Logout</a>
        </div>
      </OverlayPanel>
    </div>
    <Dialog header="Sign out" :visible.sync="displayLogout" :style="{width: '350px','text-align': 'center'}" :modal="true" :position="position">
      <div class="confirmation-content">
        <span>Are you sure, you want to sign out?</span>
      </div>
      <template #footer>
        <div class="custom-center">
          <!--          <Button label="Cancel" @click="closeLogout()" class="p-button-text p-button-danger default-custom-btn" />-->
          <!--          <Button label="Confirm" @click="validateLogout()" class="p-button-text default-custom-btn" autofocus="autofocus" />-->

          <Button label="Cancel"  @click="closeLogout()" icon="pi pi-times" class="p-button-warning" />
          <Button label="Confirm" @click="validateLogout()" icon="pi pi-check" class="p-button-danger  btn-confirm-delete-dialog" />
        </div>
      </template>
    </Dialog>

    <Dialog header="Change password" :visible.sync="displayChangePassword" :style="{width: '400px'}" :modal="true" :position="position">
      <div class="confirmation-content">
        <span class="" style="color:red" v-if='error'> {{error}}</span>
        <form action="#" autocomplete="off">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group custom-form-group" style="position: relative">
                <label class="control-label">Current password</label>
                <input id="passwordOld" v-model="passwordOld" :type='passwordType' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;margin-bottom: 15px;">
                <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibility" v-if="passwordType === 'text'">visibility</i>
                <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibility" v-else>visibility_off</i>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group custom-form-group" style="position: relative;">
                <label class="control-label">New password</label>
                <input id="passwordNew" v-model="passwordNew" :type='secondPasswordType' @keyup='checkPassword' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;margin-bottom: 15px;">
                <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityNew" v-if="secondPasswordType === 'text'">visibility</i>
                <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityNew" v-else>visibility_off</i>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group custom-form-group" style="position: relative;">
                <label class="control-label">Re-enter password</label>
                <input id="passwordConfirm" v-model="passwordConfirm" :type='confirmPasswordType' @keyup='checkPassword' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;">
                <i style="cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityConfirm" v-if="confirmPasswordType === 'text'">visibility</i>
                <i style="cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityConfirm" v-else>visibility_off</i>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template #footer>
        <div class="custom-center">

          <Button label="Cancel"  @click="closeChangePassword()" icon="pi pi-times" class="p-button-warning" />
          <Button label="Confirm" @click="submitChangePassword()" icon="pi pi-check" class="p-button-danger  btn-confirm-delete-dialog" />
          <!--          <Button label="Cancel" @click="closeChangePassword()" class="p-button-text p-button-danger default-custom-btn" />-->
          <!--          <Button label="Save" @click="submitChangePassword()" class="p-button-text default-custom-btn" autofocus />-->
        </div>
      </template>
    </Dialog>

<Dialog :visible.sync="displayRemoveNoti" id="removeNotiPopup" :containerStyle="{width: '50vw'}">
      <template #header>
        <span v-html="removeNotiTitle"></span>
      </template>
      <p class="m-0">Are you sure you want to delete this message?</p>
      <template #footer>
          <Button label="Hủy" icon="pi pi-times" @click="displayRemoveNoti = false" class="btn-cancel"/>
          <Button label="Xóa" icon="pi pi-check" @click="confirmDel" autofocus class="btn btn-danger" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import BellRingOutline from "@/components/icons/Notification";
import moment from "moment-timezone";
//import store from '../../../store'
//import firebase from 'firebase'
import Cryptojs from 'crypto-js'
export default {
   components: {
    // 'changePassword': changePassword,
    BellRingOutline,
  },
  data() {
    return {
      countNotiUnread:0,
      show: false,
      displayLogout: false,
      passwordOld: null,
      passwordNew: null,
      passwordConfirm: null,
      passwordType: 'password',
      secondPasswordType: 'password',
      confirmPasswordType: 'password',
      displayChangePassword: false,
      error: null,
      position : 'top',
      removeNotiTitle: "",
      displayRemoveNoti: false,
      removeNotiId: null,
      removeNotiIndex: null,
      notis: [],
      loadingLoadMore: false,
      offsetCurrent:0,
      totalNotis:0,
      limit: 20,
      offset: 0,
      fullname: "",
      
    }
  },
  async created() {
    await this.loadTotalNoti();
    //await this.getListNotification();
    var that = this;
setInterval(() => {
      var is_change_noti = localStorage.getItem('is_change_noti');
      console.log("is_change_noti:",is_change_noti)
      if(is_change_noti == '1'){
        localStorage.setItem('is_change_noti', '0');
        that.loadTotalNoti();
      }
    }, 10000);
  console.log("await this.getStateLogin()",(await this.$AuthenticationApp.getStateLogin()))
  var stateLogin = await this.$AuthenticationApp.getStateLogin();
  this.fullname = stateLogin?.fullname.toUpperCase() ?? '';

  },
  methods: {
    async deleteAllNoti(event) {
      event.preventDefault();
      //dùng confirm js
      const ok = window.confirm('Are you sure you want to delete all notification?');
      if (!ok) {
        return; // Người dùng nhấn Cancel
      }
      
      //this.displayRemoveNoti = true;
      // this.removeNotiTitle = data?.body ?? '';
      // this.removeNotiIndex = index;
      // this.removeNotiId =null;
      // //this.toggleNoti();
      //  console.log("this.removeNotiId:",this.removeNotiId)
      this.confirmDelAll();
    },
     async delNoti(data, index) {
      //dùng confirm js
      const ok = window.confirm('Are you sure you want to delete this message?');
      if (!ok) {
        return; // Người dùng nhấn Cancel
      }
      
      //this.displayRemoveNoti = true;
      this.removeNotiTitle = data?.body ?? '';
      this.removeNotiIndex = index;
      this.removeNotiId = data.id;
      //this.toggleNoti();
       console.log("this.removeNotiId:",this.removeNotiId)
      this.confirmDel();
    },
   async toggleNoti(event) {
    this.offset = 0;
    await this.getListNotification();
    this.$refs.notiOp.toggle(event);
    this.$nextTick(() => {
      setTimeout(() => {
        const el = document.querySelector('.class_overlay_panel_noti');
        if (el) {
          // Tuỳ chỉnh vị trí nếu cần
          el.style.top = '60px';
          el.style.left = 'calc(100% - 600px)';
        }
      }, 5);
    });
  },
  
async loadTotalNoti() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/total", {}, {headers}).then(function (response) {
            var data = response?.data?.data ?? null;
            console.log("datadatadata:",data)
            var total_unread = data?.total_item ?? 0;
            var total_all = data?.total_all ?? 0;
            that.totalNotis = total_all;
            that.countNotiUnread = total_unread;
        }).catch((err)=> {
          console.log("err1:",err)
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },
async getListNotification() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/list", {limit: this.limit, offset: this.offset}, {headers}).then(function (response) {
            var data = response?.data?.data ?? [];
             for (let i = 0; i < data.length; i++) {
                var html_body = ``;
                var item_data = data[i];
                if(item_data?.title_admin){
                  console.log(data[i]["title_admin"])
                  html_body +=`<p style="margin-bottom: 0px; font-weight: bold;">${data[i]["title_admin"]}</p>`
                }
                html_body +=data[i]["body"]
                data[i]["body"] =  html_body
             }
           // var newData = null;
            if (that.offset > 0) {
              that.notis.push(...data);
            } else {
              that.notis = data;
            }
            //that.totalNotis = data.count;
            that.loadingLoadMore = false;
        }).catch((err)=> {
          console.log(err)
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },
    async loadmoreNoti() {
      this.loadingLoadMore = true;
      if (this.notis.length < this.totalNotis) {
        this.offset = this.notis.length;
        await this.getListNotification();
      } else {
        this.loadingLoadMore = false;
      }
    },
    async confirmDelAll() {
 
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token ){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/delete", {}, {headers}).then(function () {
          window.location.reload();
          // that.$toast.add({
          //   severity: 'success',
          //   summary: "success",
          //   detail: `Delete notification successful`,
          //   life: 3000
          // });
        }).catch((err)=> {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },
    async confirmDel() {
 
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && this.removeNotiId){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/delete", {notification_id: this.removeNotiId}, {headers}).then(function () {
          that.notis.splice(that.removeNotiIndex, 1);
          that.displayRemoveNoti = false;
          that.removeNotiTitle = "";
          that.removeNotiIndex = null;
          that.removeNotiId = null;
          that.loadTotalNoti();
          that.$toast.add({
            severity: 'success',
            summary: "success",
            detail: `Delete notification successful`,
            life: 3000
          });
        }).catch((err)=> {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },
    async readNoti(data) {
      // if(data){
      //   console.log("Dadasda:data",data)
      //   return;
      // }
      if (!data.is_read) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/notification/read", {notification_id: data.id}, {headers}).then(function () {
            data.is_read = true;
            that.loadTotalNoti();
          }).catch((err)=> {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
          })
        }
      } 

      if(data.link_redirect){
        const now = Date.now(); // ví dụ: 1722570900644
        const redirectLink = `${data.link_redirect}${data.link_redirect.includes('?') ? '&' : '?'}_key_time_data=${now}`;

        window.location.href = redirectLink;
      }

    },
    async readAllNoti(event) {
      event.preventDefault();
      const ok = window.confirm('Are you sure you want to read all notification?');
      if (!ok) {
        return; // Người dùng nhấn Cancel
      }
      // if(data){
      //   console.log("Dadasda:data",data)
      //   return;
      // }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/notification/read", {}, {headers}).then(function () {
            window.location.reload();
          }).catch((err)=> {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
          })
        }

    },
    onMenuToggle(event) {
      this.$emit('menu-toggle', event);
    },
    OnShow(event) {
      this.$refs.op.toggle(event);
    },
    submitLogout() {
      this.displayLogout = true;
      // this.$modal.show(mdLogout, {}, {
      //   clickToClose: false,
      //   height: 'auto',
      //   adaptive: true,
      //   classes: ['col-md-6'],
      //   reset: true
      // })
    },
    closeLogout() {
      this.displayLogout = false;
    },
    closeChangePassword() {
      this.displayChangePassword = false;
    },
    openChangePassword() {
      // close pop-up edit profile
      //this.$emit('close')
      this.error = null;
      this.passwordOld = null;
      this.passwordNew = null;
      this.passwordConfirm = null;
      this.displayChangePassword = true;
      try {
        this.displayChangePassword = true;
      } catch (e) {
        console.error(e)
      }
    },
    validateLogout() {
      // console.log('Logout')
      this.$AuthenticationApp.clearDataLogout().then(() => {
        //this.$emit('close')
        this.displayLogout = false;
        //this.$router.push('/auth/login')
      })
    },
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityNew() {
      this.secondPasswordType = this.secondPasswordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityConfirm() {
      this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password'
    },
    checkPassword() {
      // console.log(e)
      if (this.passwordConfirm !== this.passwordNew) {
        this.matched = false
      } else {
        this.matched = true
      }
    },
    async submitChangePassword() {
      var that = this;
      if (!this.$commonFuction.isEmpty(this.passwordConfirm)
          && !this.$commonFuction.isEmpty(this.passwordOld)
          && !this.$commonFuction.isEmpty(this.passwordNew)
      ) {
        if (this.matched == false){
          this.error = 'New password does not match.';
          return false;
        }
        //console.log("await this.getStateLogin()",(await this.$AuthenticationApp.getToken()))
        const headers = {
          "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
        };
        that.$commonFuction.is_loading(true);
        var dataChangePassword = {
          password_current: (Cryptojs.SHA256(this.passwordOld.toString())).toString() ,
          password_new: (Cryptojs.SHA256(this.passwordNew.toString())).toString() ,
        }
        ApiRepository.post(this.$constants.API.CHANGE_PASSWORD, dataChangePassword, {headers}).then(async (res) => {
          console.log('=========> createUser: ', res)
          that.$toast.add({severity: 'success', summary: 'Success', detail: 'Change password successfully', life: 3000});
          that.$commonFuction.is_loading(false);
          that.displayChangePassword = false;
          //logout ra
          that.$AuthenticationApp.clearDataLogout().then(() => {
            this.$router.push('/auth/login')
          })
        })
            .catch(async error => {
              //this.errorMessage = error.message;
              var message = error.response.data.message;
              //console.error("There was an error!", message);
              switch(message) {
                case that.$constants.MSG_ERROR.INVALID_TOKEN_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.SESION_LOGIN_EXPIRED,
                    life: 3000
                  });
                  await that.$commonFuction.sleep(2000);
                  //logout
                  that.$AuthenticationApp.clearDataLogout().then(() => {})
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.MISMATCH_PARAMS_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.INVALID_CURRENT_PASSWORD_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.INVALID_CURRENT_PASSWORD_ERR,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.PASSWORD_NEW_NOT_SAME_PASSWORD_CURRENT_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.PASSWORD_NEW_NOT_SAME_PASSWORD_CURRENT_ERR,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                default:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
              }
            });
      } else  {
        // console.log(this.$refs)
        this.error = 'Please enter full information.'
      }
    }
  },
  filters: {
    formatDateTime: function (value) {
      var time_zone_local = moment.tz.guess(true);
      var newValue = null
      if (!value) return newValue
      if (moment.tz(value, time_zone_local).format("DD/MM/yyyy") == moment.tz(new Date(), time_zone_local).format("DD/MM/yyyy")) {
        newValue = moment.tz(value, time_zone_local).format("HH:mm");
      } else if (moment.tz(value, time_zone_local).format("yyyy") == moment.tz(new Date(), time_zone_local).format("yyyy")) {
        newValue = moment.tz(value, time_zone_local).format('DD [thg] MM');
      } else {
        newValue = moment.tz(value, time_zone_local).format("DD/MM/yyyy");
      }
      return newValue;
    }
  }
}
</script>
<style lang="scss">
.fontsize {
  font-size: 13px;
}
#overlay_panel {
  top: 15px !important;
  left: unset !important;
  right: 0 !important;
}
.form-custom-pass{
  padding-right: 40px !important;
  padding-right: 42.5px;
  border-radius: 3px !important;
  box-shadow: none;
  border-color: #d2d6de;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  font-family: inherit;
}
.lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    bottom: 10px;
}
.custom-pass-input{
  margin-top: 2px;
}
.default-custom-btn{
  width: 125px !important;
}
.custom-center{
  text-align: center;
}
.p-dialog-header{
  padding: 16px 24px !important;
  .p-dialog-title{
    font-weight: bold;
    font-size: 18px;
    color: #1D3118;
  }

  background-color: #F4F4F4 ;
  border-bottom: 1px solid #C8C8C8;
}

.p-dialog-content{
  padding: 24px !important;
  border-bottom: 1px solid #D0D4D9;
  .control-label{
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  .form-control{
    height: 48px;
  }
}

.p-dialog-footer{
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px !important;
  .btn-cancel{
    background-color: #F2F3F7;
    border: unset;
    color: #333333;
    .p-button-label{
      color: #333333 !important;
    }
    text-transform: none;
    font-size: 16px;
    // font-family: 'adobe clean', sans-serif;
    border-radius: 3px;
    padding-left: 16px;
    padding-right: 16px;
    width: auto;
    margin-top: 0 !important;
    height: 40px;
    letter-spacing: 0;
    &:hover{
      color: #333333;
      background-color: #F2F3F7;
    }
  }
  .btn-save{
    background-color: #0086C4;
    color: #FFFFFF;
    text-transform: none;
    font-size: 16px;
    // font-family: 'adobe clean', sans-serif;
    border-radius: 3px;
    padding-left: 16px;
    padding-right: 16px;
    width: auto;
    margin-top: 0 !important;
    height: 40px;
    letter-spacing: 0;
    border: unset;
    &:hover{
      color: white;
      background-color: #0086C4;
    }
  }
}
.p-overlaypanel-content{
  padding: 16px !important;
  a {
    color: #333333;
  }
  hr {
    opacity: 0.5;
    background: #EEEEEE;
    height: 1px;
  }
}
.p-dialog-mask.p-dialog-top.p-component-overlay{
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 311px){
  .p-dialog-footer{
    flex-direction: column !important;
    justify-content: end !important;
    align-items: end !important;
    .custom-center{
      text-align: end !important;
    }
    .btn-cancel{
      margin-bottom: 10px !important;
      margin-right: 0px !important;
    }
  }
}
.noti-box {
  width: 100%;
  max-height: 400px;
  overflow: auto;
}
.box-empty {
  text-align: center;
}
.noti-items {
  display: flex;
  border-bottom: 1px solid #eee;
  padding: 15px 0;
  cursor: pointer;
}
.noti-items.unread .items-title {
  color:#0086C4;
  font-weight: bold;
}
.noti-items.unread .items-title::before{
  content: "";
  border-radius: 50%;
  background-color: #0086C4;
  width: 10px;
  height: 10px;
  position: absolute;
  left: 0%;
  top: 15%;
}
.noti-items .items-title{
  flex-basis: 75%;
  padding-left: 20px;
  position: relative;
}
.noti-items .items-date {
  flex-basis: 20%;
  text-align: right;
}
.noti-items .items-icon{
  flex-basis: 5%;
  text-align: right;
}
.noti-items .items-icon:hover {
  color: #c82333 !important;
}
.noti-link-loadmore {
  color: #0086C4;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .loadmore {
    cursor: pointer;
  }
}
.noti-header {
  height: 50px;
  background-color: #F4F4F4;
  display: flex;
  align-items: center;
  .noti-header-title {
    flex-basis: 90%;
    padding: 0.571rem 1rem;
    font-weight: bold;
    color: #1D3118;
    font-size: 18px;
  }
  .pi.pi-times {
    cursor: pointer;
  }
}
#overlay_panel_noti .p-overlaypanel-content{
  padding: 0 !important;
  padding-bottom: 23px !important;
  .noti-box {
    padding: 0.571rem 1rem;
  }
}
#overlay_panel_noti {
  // z-index: 998 !important;
  position: fixed;
  display: block !important;
  top: 2em !important;
  right: 0 !important;
  width: 600px;
}
.p-dialog-mask, #removeNotiPopup {
  z-index: 2000 !important;
}

#removeNotiPopup .btn-danger:hover {
    color: #fff;
    background-color: #c82333 !important;
    border-color: #bd2130 !important;
}
.noborder {
  border: unset !important;
}

@media (max-width: 789px) {
  #overlay_panel_noti {
    width: auto !important;
  }
}
</style>
